//=============================================================================
//                       <--- Developed By Icon Team ---> 18 January 2021
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const locationStyles = makeStyles((theme) => ({
  locationsText: {
    textAlign: "left",
    font: "normal normal normal 1.5vw Segoe-ui",
    marginBottom: 0,
    letterSpacing: "0px",
    color: " #707070",
    fontSize: 28,
    display: "block",
    textAlign: "center",
  },
  topGrid: {
    display: "flex",
    alignItems: "center",
  },
  searchInput: {
    width: 400,
    borderRadius: 20,
    "@media (max-width: 600px)": {
      width: "100%",
      padding: 10,
    },
  },
  badge: {
    backgroundColor: "#C52025",
    color: "#fff",
    fontWeight: "bold",
    position: "absolute",
    right: -10,
    top: -15,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    height: 140,
    width: 100,
  },
  control: {
    padding: theme.spacing(2),
  },
  filterCardDiv: {
    "@media (max-width: 600px)": {
      overflow: "scroll",
    },
  },
  filterCard: {
    boxShadow: " 10px 10px 10px #00000029 !important",
    border: " 1px solid #707070",
    borderRadius: "20px !important",
    width: 600,
    zIndex: 100,
    marginBottom: 20,
    "@media (max-width: 600px)": {
     width: "100%"
    },
  },
  filterCardGridContainer: {
    height: "100%",
  },
  filterCardGrid: {
    borderRight: "1px solid #0000004D",
    "@media (max-width: 600px)": {
      borderRight: "none",
     },
    
  },
  filterCardHeadText: {
    fontSize: 15,
  },
  filterCardSubHeadText: {
    fontSize: 24,
  },
  filterCardInput: {
    borderRadius: 10,
  },
  filterCardBtnGrid: {
    textAlign: "center",
    alignSelf: "center",
  },
  filterCardResetBtn: {
    color: "#2F7CBD",
    backgroundColor: "#fff",
    fontSize: 22,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 150,
    height: 45,
    textTransform: "capitalize",
  },
  filterCardApplyBtn: {
    color: "#fff",
    backgroundColor: "#305698",
    fontSize: 15,
    border: " 1px solid #2F7CBD",
    borderRadius: 10,
    width: 100,
    height: 35,
    textTransform: "capitalize",
    "&:hover": {
      backgroundColor: "#305698",
    },
  },
  filterBtn: {
    marginLeft: 20,
  },
  tableDiv: {},
  emptyDataText: {
    textAlign: "center",
    fontSize: 30,
    fontFamily: "segoe-ui",
    padding: "10%",
    opacity: "0.4",
  },
  responsiveTable: {
    width: "100%",
    overflow: "auto",
    marginBottom: "100px",
  },
  searchIcon: {
    cursor: "pointer"
  },
  searchInputIcon:{
    cursor: "pointer"
  },
  switchtoInput:{
    cursor: "pointer",
    "-webkit-transform":"scale(1.5)"
  },
  dormantheading:{
    display:'flex',
    marginBottom:'15px',
    maxWidth: '800px'
   },
  dormantlabel:{
    fontSize :15,
    fontWeight:'bold'

  },
  dormantlabel1:{
    fontSize :15,
    fontWeight:'bold',
    marginLeft:'67px'

  },
  dormantlabel2:{
    fontSize :15,
    fontWeight:'bold',
    marginLeft:'33px'


  },
 
  memberheader:{
    fontSize :27,
    marginBottom:8

  }
}));
